import type { ComponentProps } from "react"

import { Button } from "@/components/ui/button"

export function ButtonBack({
  children = "Back",
  ...props
}: ComponentProps<typeof Button>) {
  return (
    <Button
      type="button"
      variant="outline"
      className="flex h-12 min-w-35 cursor-pointer items-center rounded-lg bg-white px-8 py-3 text-gray-700 hover:bg-gray-200"
      {...props}
    >
      {children}
    </Button>
  )
}
